import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import PhotoGalleryImage from './PhotoGalleryImage';

export default function PhotoGalleryImages({ images, theme }) {
  if (_.isEmpty(images)) return null;

  return _.map(images, image => <PhotoGalleryImage image={image} theme={theme} />);
}

PhotoGalleryImages.defaultProps = {
  images: null,
};

PhotoGalleryImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})),
  theme: PropTypes.shape({}).isRequired,
};
